import { withProps } from "mosha-vue-toastify";
import ToastContent from "@/components/Recurring/ToastContent.vue";

/**
 * Показує toast з кастомним компонентом ToastContent.
 *
 * @param {Function} $moshaToast - toast-функція (береться з this або proxy.$moshaToast)
 * @param {string} type - тип повідомлення ("success", "error" і т.д.)
 * @param {string} msg - текст повідомлення
 * @param {Object} options - додаткові налаштування для тоста (необов'язково)
 *
 * ✅ Приклад (Options API):
 * showToast(this.$moshaToast, "success", "Успішно!");
 *
 * ✅ Приклад (Composition API):
 * const { proxy } = getCurrentInstance();
 * showToast(proxy.$moshaToast, "error", "Фейл!", { timeout: 5000 });
 */

export const showToast = ($moshaToast, type, msg, options = {}) => {
    const defaultOptions = {
        hideProgressBar: true,
        timeout: 3000,
        position: 'top-right',
        draggable: false,
        showIcon: false,
        transition: 'bounce',
        closeOnClick: false,
        pauseOnHover: true,
        pauseOnFocusLoss: true,
        rtl: false,
        closeButton: false
    };

    $moshaToast(
        withProps(ToastContent, { 
            msg, 
            type,
        }),
        { ...defaultOptions, ...options }
    );
};
